module.exports = __webpack_public_path__ + "img/camperdrive-big-1.e1c1d804.jpg";